import { Route } from 'react-router-dom';
import { UsAmpDashboard } from './entities/usamp/UsAmpDashboard';

const bmsScRoutes = [
  <Route path="/sc/dashboard/us-amp" element={<UsAmpDashboard />} />,
]

export default bmsScRoutes;